export class Fornecedor {
    id: number;
    nomeFantasia: string;
    razaoSocial: string;
    address: string;
    block: string;
    batch: string;
    telephone: string;
    complement: string;
    observation: string;
    cidade: string;
    estado: string;
    bairro: string;
    cep?: string;

    constructor(id: number, nomeFantasia: string, razaoSocial: string, address: string, block: string, batch: string, telephone: string, complement: string, observation: string,
        cidade: string, estado: string, bairro: string, cep?: string) {
        this.id = id;
        this.nomeFantasia = nomeFantasia;
        this.razaoSocial = razaoSocial;
        this.address = address;
        this.block = block;
        this.batch = batch;
        this.telephone = telephone;
        this.complement = complement;
        this.observation = observation;
        this.cidade = cidade;
        this.estado = estado;
        this.bairro = bairro;
        this.cep = cep;
    }
}